module.exports = __webpack_public_path__ + "img/more-offers-icon.c2c278a5.svg";